import classNames from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
import Slider from 'react-slick';

import { CarouselNextArrow } from '../components/CarouselNextArrow';
import { CarouselPrevArrow } from '../components/CarouselPrevArrow';
import { useScreenSize } from '../hooks/use-screen-size';
import { LessonCard, LessonCardProps } from './LessonCard';

export interface LessonCarouselProps {
  lessons: LessonCardProps[] | undefined;
  exampleBg?: boolean;
  className?: string;
  currentLessonIndex: number;
}

export const LessonCarousel = ({
  currentLessonIndex = 0,
  lessons = [],
  className,
  exampleBg,
}: LessonCarouselProps) => {
  const { width, screenSizes } = useScreenSize();
  const slider = useRef<Slider>(null);

  const slidesToShow = useMemo(() => {
    if (width <= screenSizes.md) {
      return 1;
    } else if (width <= screenSizes.xl) {
      return 2;
    } else if (lessons.length < 3) {
      return lessons.length;
    }
    return 3;
  }, [width, lessons]);

  const settings = {
    arrows: true,
    centerMode: false,
    infinite: false,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <CarouselNextArrow />,
    prevArrow: <CarouselPrevArrow />,
  };

  useEffect(() => {
    if (slider.current) {
      slider.current.slickGoTo(currentLessonIndex);
    }
  }, [slider, currentLessonIndex]);

  return (
    <Slider
      {...settings}
      className={classNames('lessons-carousel', exampleBg && 'example-bg', className)}
      ref={slider}
    >
      {lessons.map((slide, key) => {
        return (
          <div key={key}>
            <div className="slide-content">
              <LessonCard
                buttonText={slide.buttonText}
                imgSrc={slide.imgSrc}
                href={slide.href}
                status={slide.status}
                subtitle={slide.subtitle}
                title={slide.title}
                type={slide.type}
                position={slide.position}
              />
            </div>
          </div>
        );
      })}
    </Slider>
  );
};
